import React from 'react';

import CommonImage from '@components/CommonImage';

const CostingSidebar = () => {
	return (
		<>
			<div className="costing-sidebar shadow-8dp">
				<div className="costing-sidebar-header border-bottom">
					<div className="d-flex justify-content-between px-4 py-3">
						<p className="semibold-14 reqular-14">Costing History</p>
						<CommonImage src="/icons/close.svg" className="cursor-pointer" />
					</div>
				</div>

				<div className="costing-sidebar-body scroll-y-label px-4">
					<div className="costing-history-item border p-3 mt-4">
						<div className="d-flex justify-content-between">
							<div>
								<p className="semibold-14 reqular-14">Costing History</p>
								<ul className="common-list-component pt-1">
									<li className="regular-12 gray_dark_02 d-flex align-items-center gap-1">
										<span>
											<CommonImage
												src="/images/pro_pic_default.svg"
												width={14}
												height={14}
											/>
										</span>{' '}
										abdullah
									</li>
									<li className="regular-12 gray_dark_02 d-flex align-items-end gap-1">
										<span>
											<CommonImage
												src="/images/icons/calendar.svg"
												width={14}
												height={14}
											/>
										</span>{' '}
										26 Oct 2023
									</li>
								</ul>
							</div>
							<div>
								<p className="semibold-14 reqular-14">Fob</p>
								<p className="regular-12 gray_dark_02 pt-1">$100</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};
export default CostingSidebar;
